import { useTranslation } from "react-i18next"

import { COPY_VARIANT_KEY_ICON_TIMEOUT } from "shared/constants/app-constants"
import { raiseToast } from "shared/lib/toast/raiseToast"
import { useBooleanState } from "shared/lib/useBooleanState"
import { useEvent } from "shared/lib/useEvent"
import { ToastType } from "shared/types/Toast"

interface UseClipboardOptions {
  successMessage?: string
  errorMessage?: string
  resetDelay?: number
}

export function useClipboard(options: UseClipboardOptions = {}) {
  const { t } = useTranslation()
  const {
    successMessage = t("General.CopiedToClipboard"),
    errorMessage = t("General.Error"),
    resetDelay = COPY_VARIANT_KEY_ICON_TIMEOUT
  } = options

  const {
    value: isCopied,
    setTrue: setIsCopiedTrue,
    setFalse: setIsCopiedFalse
  } = useBooleanState(false)

  const copy = useEvent((text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setIsCopiedTrue()
        setTimeout(setIsCopiedFalse, resetDelay)
        raiseToast({ message: successMessage, type: ToastType.SUCCESS })
      })
      .catch(() => {
        raiseToast({ message: errorMessage, type: ToastType.ERROR })
      })
  })

  return { copy, isCopied }
}
